import { createSelector } from '@reduxjs/toolkit';
import { Group } from '../api/group.model';
import { getRightUserUtilSelector } from '../../rights/selectors';
import { RootState } from '../../store.model';
import { getAllGroups, getGroupsLoading } from '.';
import { getMyWorkspaceIdSelector } from '../../stoerkID/selectors/StoerkId.selectors';

const getGroupIdFromProps = (_: any, props: { group?: Group }) => props.group;

export const groupButtonsRightsSelector = createSelector(
  [
    getGroupIdFromProps,
    getRightUserUtilSelector,
    (state: RootState) => state.featureToggle,
    getMyWorkspaceIdSelector,
  ],
  (group, rightsUserUtil, featureToggle, workspaceId) => {
    const groupId = group?.id ?? '';
    const showButtonReadIncidents = !!rightsUserUtil.hasRightsToReadIncident(
      null,
      groupId,
      workspaceId
    );
    const showButtonUpdateGroup = !!rightsUserUtil.hasRightsToUpdateGroup(
      groupId,
      workspaceId
    );
    const showButtonDeleteGroup = !!rightsUserUtil.hasRightsToDeleteGroup(
      groupId,
      workspaceId
    );
    const showButtonRecipeGroup = !!(
      featureToggle.recipeManager &&
      rightsUserUtil.hasRightsToReadRecipe(null, groupId, workspaceId)
    );
    const showButtonCameraGroups = !!featureToggle.camera;
    const contacts = group?.attributes?.contacts ?? [];
    const showButtonContacts = contacts.length > 0;

    return {
      showButtonReadIncidents,
      showButtonUpdateGroup,
      showButtonDeleteGroup,
      showButtonRecipeGroup,
      showButtonCameraGroups,
      showButtonContacts,
    };
  }
);

export const getDashboardRightsSelector = createSelector(
  [
    getRightUserUtilSelector,
    getAllGroups,
    getGroupsLoading,
    getMyWorkspaceIdSelector,
  ],
  (rightsUserUtil, groups, isFirstLoad, workspaceId) => {
    const canViewOperatorDashboard = groups.some((group) =>
      rightsUserUtil.hasRightsToViewDashboardAsOperator(
        null,
        group.id,
        workspaceId
      )
    );

    const canViewRegionalManagerDashboard = groups.some((group) =>
      rightsUserUtil.hasRightsToViewDashboardAsManager(
        null,
        group.id,
        workspaceId
      )
    );

    return {
      canViewOperatorDashboard,
      canViewRegionalManagerDashboard,
      isFirstLoad,
    };
  }
);
